import { Status } from 'API';

import './_styles.scss';

interface Props {
    status?: Status;
}

const SystemUsersRowStatus = ({ status }: Props) => {
    switch (status) {
        case Status.ACTIVE:
            return (
                <div
                    data-testid='system-user-status-active'
                    className='SystemUsersRowStatus__chip SystemUsersRowStatus__chip--active'
                >
                    ACTIVE
                </div>
            );
        case Status.INVITED:
            return (
                <div data-testid='system-user-status-invited' className='SystemUsersRowStatus'>
                    <div className='SystemUsersRowStatus__chip SystemUsersRowStatus__chip--invited'>INVITED</div>
                </div>
            );
        default:
            return null;
    }
};

export default SystemUsersRowStatus;
